type InviteAttributes = {
  email: string
  id: string
  user_id: string
}

export default class Invite {
  email: string
  id: string
  user_id: string

  constructor(params: InviteAttributes) {
    this.email = params.email
    this.id = params.id
    this.user_id = params.user_id
  }

  getRedirectUrl(utmContent: string) {
    if (this.user_id) {
      return `${process.env.GATSBY_SERVER_URL}/login?email=${encodeURIComponent(this.email)}&utm_content=${utmContent}`
    } else {
      return `${process.env.GATSBY_SERVER_URL}/signup?utm_content=${utmContent}&invite_id=${encodeURIComponent(
        this.id,
      )}`
    }
  }
}
